import { ImageDimension } from './comment/types'

export type MyCommunity = {
  id: number
  name: string
  membershipSlug: string
  lastPostDate: number
  icon?: string
  membershipName?: string
  hasTrendingPost?: boolean
  hasUnseenContent?: boolean
}

export type GetCommentImageProps = {
  publicationId: number
  commentId: number
  imageDimension: ImageDimension
  redirect?: boolean
  isUnauthenticated?: boolean
}

type CommunityGroup = {
  communities: {
    data: CommunityProps[]
  }
} & CommunityGroupCreateResponse

export type CommunityGroupsResponse = {
  hasCommunityToMigrate: boolean
  groups: CommunityGroup[]
}

export type CommunityProps = {
  id: number
  name: string
  isLocked: boolean
  url?: string
  description?: string
  imageURL: string
  coverImageURL?: string
  imageDescription: string
  coverDescription?: string
  permissions?: CommunityMemberPermissions
  owner: string
  lastPostDate: number
  followersCount: number
  isOwner?: boolean
  isFollowing?: boolean
  ownerId?: number
  ownerUcode?: string
  ownerPictureUrl?: string
  isOwnerOrFollower?: boolean
  icon?: string
  idGroup?: number
  hasUnseenNewsOrCommentReplies?: boolean
  order?: number
  type: COMMUNITY_TYPE
  isCollaborative?: boolean
  isDefaultEnableComments?: boolean
  isHide?: boolean
  isModerationCommunity?: boolean
}

export type CommunityGroupCreateResponse = {
  id: number
  name: string
  slug: string
  order: number
}

export type CommunityMemberPermissions = {
  group: CommunityMemberPermissionsGroup
  actions?: Array<PermissionActions>
}

export enum CommunityMemberPermissionsGroup {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR',
  FOLLOWER = 'FOLLOWER',
  VIEWER = 'VIEWER'
}

export enum PermissionActions {
  ACCESS_AND_PRIVACY = 'ACCESS_AND_PRIVACY',
  ADMIN_UPDATE = 'ADMIN_UPDATE',
  BLOCK_ADMIN_CREATE = 'BLOCK_ADMIN_CREATE',
  BLOCK_CREATE = 'BLOCK_CREATE',
  BLOCK_DELETE = 'BLOCK_DELETE',
  BLOCK_MEMBER_CREATE = 'BLOCK_MEMBER_CREATE',
  BLOCK_MODERATOR_CREATE = 'BLOCK_MODERATOR_CREATE',
  BLOCK_READ = 'BLOCK_READ',
  COLLECTION_DELETE = 'COLLECTION_DELETE',
  COLLECTION_UPDATE = 'COLLECTION_UPDATE',
  COMMENT_DELETE = 'COMMENT_DELETE',
  COMMENT_HIDE = 'COMMENT_HIDE',
  COMMENT_SORTITION_CREATE = 'COMMENT_SORTITION_CREATE',
  FOLLOW_REQUEST_READ = 'FOLLOW_REQUEST_READ',
  FOLLOW_REQUEST_UPDATE = 'FOLLOW_REQUEST_UPDATE',
  GROUP_CREATE = 'GROUP_CREATE',
  GROUP_DELETE = 'GROUP_DELETE',
  GROUP_READ = 'GROUP_READ',
  GROUP_UPDATE = 'GROUP_UPDATE',
  IMPORT_MEMBER = 'IMPORT_MEMBER',
  MEMBER_DELETE = 'MEMBER_DELETE',
  MEMBER_ROLE_READ = 'MEMBER_ROLE_READ',
  MEMBER_UPDATE = 'MEMBER_UPDATE',
  MODERATOR_UPDATE = 'MODERATOR_UPDATE',
  PIN_CREATE = 'PIN_CREATE',
  PIN_DELETE = 'PIN_DELETE',
  POST_CREATE = 'POST_CREATE',
  POST_DELETE = 'POST_DELETE',
  POST_REVIEW_UPDATE = 'POST_REVIEW_UPDATE',
  SCHEDULED_POST_CREATE = 'SCHEDULED_POST_CREATE',
  SCHEDULED_POST_DELETE = 'SCHEDULED_POST_DELETE',
  SCHEDULED_POST_READ = 'SCHEDULED_POST_READ',
  STRIKE_CREATE = 'STRIKE_CREATE',
  STRIKE_DELETE = 'STRIKE_DELETE',
  STRIKE_READ = 'STRIKE_READ'
}

export enum COMMUNITY_TYPE {
  PUBLIC = 1,
  OPEN = 2,
  EXCLUSIVE = 3,
  PAID = 4
}
